import { LoggerService } from "services/logger.service";
import { RequestOrderItem } from "store/back-counter/back-counter.entities";
import { mapCoreOption } from "store/back-counter/back-counter.reducer.util";

export const mapPartToRequestOrderItem = (
  part: any,
  item: { orderNumber: string; jobNumber: string; mainPrItem: string },
  loggerService: LoggerService
): RequestOrderItem & { quantityAvailable: number } => {
  const isBuyout = part.successMessage?.includes("PARTSBUYOUTTX");
  const coreOption = isBuyout
    ? part?.addNonInventoryPartBuyout?.addCartItemRequest?.coreOption
    : part.coreOption;
  loggerService.info("openSearchModal - isBuyout: ", isBuyout);
  loggerService.info("openSearchModal - coreOption: ", coreOption);
  return {
    material: part?.addNonInventoryPartBuyout?.addCartItemRequest?.partNumber,
    itemNumber: null,
    orderNumber: item.orderNumber,
    jobNumber: item.jobNumber,
    orderQuantity: part.quantity,
    quantityAvailable: part.quantityAvailable ?? 0,
    purchaseVendor: null,
    freight: "",
    mainPrItem: item.mainPrItem,
    coreOption: isBuyout ? "" : mapCoreOption(coreOption),
    materialNumber:
      part.rushPartNumber ??
      part?.addNonInventoryPartBuyout?.addCartItemRequest?.partNumber,
    deliveryDate: "",
    deliveryOption: part?.deliveryOption,
    itemCategory: isBuyout ? "P010" : "P002",
    orderUom: part.unitOfMeasure,
    corePrice: part?.addNonInventoryPartBuyout?.coreCustomerPrice ?? 0,
    manualPrice: part?.addNonInventoryPartBuyout?.customerPrice,
    unsavedChanges: "ADD",
    itemTotal: isBuyout ? part.price : part.listPrice,
    descr1: part?.partNumber?.slice(0, 40),
    description: part?.description,
    coreCharges: part?.corePrice,
    coreChargesPerQuantity: part?.corePrice,
    reqQuantity: part.quantity,
    vendor: part?.addNonInventoryPartBuyout?.vendorCode,
    cost: part?.addNonInventoryPartBuyout?.purchasePrice ?? part?.cost,
    price: part?.addNonInventoryPartBuyout?.customerPrice ?? 0,
    pbCoreOption:
      part?.addNonInventoryPartBuyout?.addCartItemRequest?.coreOption,
    coreCustPrice: part?.addNonInventoryPartBuyout?.coreCustomerPrice ?? 0,
    corePurcPrice: part?.addNonInventoryPartBuyout?.corePurchasePrice ?? 0,
    purchasePrice: part?.addNonInventoryPartBuyout?.purchasePrice,
    buyout: isBuyout ? "X" : "",
    unitPrice: isBuyout ? part.price : part.listPrice,
    coupTotal: Math.abs(part.couponTotal ?? 0) * (part.quantity ?? 1),
    coupon: Math.abs(part.couponTotal ?? 0),
    couponPerQuantity: Math.abs(part.couponTotal ?? 0),
    finalPrice: part?.listPrice ?? 0,
  };
};
